<div class="modal-header">
  <h5 class="modal-title">{{ title }}</h5>
  <button (click)="close()" type="button" class="close">
    <i class="far fa-times"></i>
  </button>
</div>
<div *ngIf="isDuplicate" class="mx-3 mt-3">
  <alert type="warning">
    <strong i18n>Warning:</strong>
    <ng-container i18n>This expense is a duplicate. Please modify the expense details, before clicking</ng-container>
    <strong i18n>Save</strong> <ng-container i18n>to create the expense.</ng-container>
  </alert>
</div>

<div class="modal-body">
  <ul class="nav top-navbar border-bottom mb-3">
    <li [class.active]="activeTab === tabs.Expense">
      <a (click)="activeTab = tabs.Expense" i18n> Details </a>
    </li>
    <li [class.active]="activeTab === tabs.Recurring">
      <a (click)="activeTab = tabs.Recurring" i18n> Recurring </a>
    </li>
    <li [class.active]="activeTab === tabs.Attachments">
      <a (click)="activeTab = tabs.Attachments" i18n> Attachments </a>
    </li>
    <ng-container *ngIf="isEdit">
      <li [class.active]="activeTab === tabs.Attributes">
        <a (click)="activeTab = tabs.Attributes" i18n> Custom Attributes </a>
      </li>
      <li [class.active]="activeTab === tabs.Comments">
        <a (click)="activeTab = tabs.Comments" i18n> Comments </a>
      </li>
      <li [class.active]="activeTab === tabs.Activity">
        <a (click)="activeTab = tabs.Activity" i18n> Logs </a>
      </li>
    </ng-container>
  </ul>
  <ng-container [ngSwitch]="activeTab">
    <ng-template *ngSwitchCase="tabs.Expense" [ngTemplateOutlet]="detailsForm"></ng-template>
    <ng-template *ngSwitchCase="tabs.Recurring" [ngTemplateOutlet]="recurringForm"></ng-template>
    <ng-template *ngSwitchCase="tabs.Attachments" [ngTemplateOutlet]="attachmentsTab"></ng-template>
    <ng-template *ngSwitchCase="tabs.Comments" [ngTemplateOutlet]="comments"></ng-template>
    <ng-template *ngSwitchCase="tabs.Activity" [ngTemplateOutlet]="activity"></ng-template>
    <div *ngSwitchCase="tabs.Attributes">
      <app-entity-attributes
        #attrs
        entityType="expense"
        [entityId]="expenseId"
        [showActions]="false"
      ></app-entity-attributes>
    </div>
  </ng-container>
</div>
<div class="text-muted text-sm mt-1 mx-3" *ngIf="expenseId">
  <ng-container i18n>Expense ID</ng-container>: {{ expenseId }}
  <app-copy-icon [content]="expenseId"></app-copy-icon>
</div>
<div class="modal-footer">
  <button *ngIf="isEdit" (click)="onRemove(expense)" type="button" class="btn btn-secondary-danger">
    <i class="cs-icon cs-icon-trash"></i> <ng-container i18n>Delete</ng-container>
  </button>
  <button (click)="close()" type="button" class="btn btn-light ml-auto">
    <span class="far fa-times"></span>
    <ng-container i18n>Cancel</ng-container>
  </button>
  <ng-container *ngIf="activeTab === tabs.Attributes && attrs">
    <button (click)="attrs.onConfig()" [disabled]="1 | isReadonlyRole" type="button" class="btn btn-secondary-primary">
      <span class="cs-icon cs-icon-cog"></span>
      <ng-container i18n>Attributes Configuration</ng-container>
    </button>
    <button
      (click)="onSaveAttrs()"
      [disabled]="(1 | isReadonlyRole) || attrs.isSaving"
      type="button"
      class="btn btn-secondary-info"
    >
      <i class="cs-icon cs-icon-save" *ngIf="!attrs.isSaving"></i>
      <i class="far fa-spin fa-spinner" *ngIf="attrs.isSaving"></i>
      <ng-container i18n>Save</ng-container>
    </button>
  </ng-container>
  <button
    *ngIf="activeTab !== tabs.Attributes"
    (click)="save()"
    [disabled]="1 | isReadonlyRole"
    type="button"
    class="btn btn-secondary-info"
  >
    <span class="cs-icon cs-icon-save"></span>
    <ng-container i18n>Save</ng-container>
  </button>
</div>

<ng-template #detailsForm>
  <form [formGroup]="form" [formEditablePermission]="form">
    <div class="row">
      <div class="col-md-6">
        <app-rental-select
          [multiple]="false"
          [matTooltip]="rentalTooltip"
          matTooltipPosition="left"
          [ctrl]="form.get('rental_id')"
          (selectedItemsChange)="form.get('inquiry_id').reset()"
          placeholder="Rental"
          i18n-placeholder
        >
        </app-rental-select>
      </div>
      <div class="col-md-6">
        <mat-form-field2 class="mat-block">
          <input
            type="text"
            [matTooltip]="categoryTooltip"
            matTooltipPosition="left"
            placeholder="Category"
            i18n-placeholder
            matInput
            [formControl]="form.get('category')"
            [matAutocomplete]="auto"
            required
          />
          <mat-autocomplete #auto="matAutocomplete">
            <mat-option *ngFor="let category of categories$ | async" [value]="category.value">
              {{ category.label }}
            </mat-option>
          </mat-autocomplete>
          <mat-error *ngIf="form.get('category').touched && form.get('category').hasError('required')">
            <ng-container i18n>Category is required</ng-container>
          </mat-error>
        </mat-form-field2>
      </div>
      <div class="col-md-6">
        <app-booking-select
          [tooltipText]="inquiryTooltip"
          [ctrl]="form.get('inquiry_id')"
          (selected)="onSelectInquiry($event)"
          [rentalId]="form.get('rental_id').value"
        ></app-booking-select>
      </div>
      <div class="col-md-3">
        <mat-form-field2 class="mat-block" matTooltip="Select the expense date" i18n-matTooltip>
          <input
            matInput
            [matDatepicker]="expenseDate"
            [min]="minDateDefault"
            [max]="maxDateDefault"
            placeholder="Expense Date"
            i18n-placeholder
            [required]="true"
            (focus)="expenseDate.open()"
            formControlName="date"
            readonly
          />
          <i matSuffix (click)="expenseDate.open()" class="cs-icon cs-icon-calendar"></i>
          <mat-datepicker #expenseDate></mat-datepicker>
          <mat-error *ngIf="form.get('date').touched && form.get('date').hasError('required')">
            <ng-container i18n>Expense Date is required</ng-container>
          </mat-error>
        </mat-form-field2>
      </div>
      <div class="col-md-3">
        <mat-form-field2 class="mat-block" matTooltip="Select the due date for this expense" i18n-matTooltip>
          <input
            matInput
            [matDatepicker]="dueDatePicker"
            [max]="maxDateDefault"
            [min]="form.get('date').value || minDateDefault"
            placeholder="Due Date"
            i18n-placeholder
            (focus)="dueDatePicker.open()"
            formControlName="due"
            readonly
          />
          <i matSuffix (click)="dueDatePicker.open()" class="cs-icon cs-icon-calendar"></i>
          <mat-datepicker #dueDatePicker></mat-datepicker>
          <mat-error *ngIf="form.get('due').touched && form.get('due').hasError('required')">
            <ng-container i18n>Due Date is required</ng-container>
          </mat-error>
          <mat-error *ngIf="form.get('due').hasError('matDatepickerMin')">
            <ng-container i18n>Min value is</ng-container>&nbsp;
            <strong>{{ form.get('due').getError('matDatepickerMin').min | epoch : 'DD-MMM-YYYY' }}</strong>
          </mat-error>
        </mat-form-field2>
      </div>
      <div class="col-md-6">
        <mat-form-field2 class="mat-block" matTooltip="Enter the amount of expense" i18n-matTooltip>
          <input
            matInput
            decimal
            required
            placeholder="Amount"
            i18n-placeholder
            formControlName="amount"
            type="number"
          />
          <mat-error *ngIf="form.get('amount').touched && form.get('amount').hasError('required')">
            <ng-container i18n>Amount is required</ng-container>
          </mat-error>
        </mat-form-field2>
      </div>
      <div class="col-md-6">
        <mat-form-field2 class="mat-block" matTooltip="Select the payment method for this expense" i18n-matTooltip>
          <mat-select formControlName="method" placeholder="Payment Method" i18n-placeholder>
            <mat-option *ngFor="let method of methodOptions" [value]="method.value">{{ method.name }}</mat-option>
          </mat-select>
        </mat-form-field2>
      </div>
      <ng-container *ngIf="isEdit">
        <ng-template *ngIf="isAdmin" [ngTemplateOutlet]="approveField"></ng-template>
        <ng-template
          *ngIf="!isAdmin && (approvable$ | async)?.amount >= form.get('amount').value"
          [ngTemplateOutlet]="approveField"
        ></ng-template>
      </ng-container>
      <ng-template #approveField>
        <div class="col-md-6">
          <mat-form-field2 class="mat-block">
            <mat-select formControlName="approval_status" placeholder="Approval Status" i18n-placeholder>
              <mat-option *ngFor="let item of approvalStatuses" [value]="item.id">{{ item.label }}</mat-option>
            </mat-select>
          </mat-form-field2>
        </div>
      </ng-template>
      <div class="col-md-6 my-3">
        <mat-checkbox
          formControlName="status"
          class="mt-3"
          matTooltip="Mark the status of expense"
          i18n-matTooltip
          i18n
        >
          Paid
        </mat-checkbox>
      </div>
    </div>

    <div class="row">
      <div class="col-md-12 position-relative">
        <mat-form-field2 class="mat-block mat-txt-area" cdkOverlayOrigin #aiSuggestionsTrigger="cdkOverlayOrigin">
          <textarea
            matInput
            formControlName="description"
            #notes
            maxlength="500"
            rows="3"
            placeholder="Description"
            i18n-placeholder
            cdkTextareaAutosize
          ></textarea>
          <mat-hint align="end">{{ notes.value?.length || 0 }}/500</mat-hint>
        </mat-form-field2>
        <app-ai-suggestions-icon
          *ngIf="expenseId"
          [entityId]="expenseId"
          [length]="250"
          type="expense_description"
          [attachTo]="aiSuggestionsTrigger"
          [width]="aiSuggestionsTrigger.elementRef?.nativeElement.clientWidth"
          (apply)="form.get('description').setValue($event)"
          tooltipText="Generate suggestions for the expense description"
          i18n-tooltipText
          class="position-absolute"
          style="bottom: 2rem; right: 2rem"
        ></app-ai-suggestions-icon>
      </div>
    </div>
  </form>
</ng-template>

<ng-template #recurringForm>
  <app-recurring-form [form]="repeatOptionsForm" [repeatableCtrl]="form.get('repeat')"></app-recurring-form>
</ng-template>

<ng-template #comments>
  <app-comments-list entityType="expense" [entityId]="expenseId">
    <app-empty-table type="CommentsList"></app-empty-table>
  </app-comments-list>
</ng-template>

<ng-template #activity>
  <app-activity-table entityType="expense" [entityId]="expenseId">
    <app-empty-table type="ActivityList"></app-empty-table>
  </app-activity-table>
</ng-template>

<ng-template #attachmentsTab>
  <app-upload-box
    [options]="uploadBoxOptions"
    [showFileList]="false"
    [uploadedCount]="attachments.length"
    (complete)="onFileUploaded($event)"
    *ngIf="attachments?.length < uploadBoxOptions.maxUploads && !(1 | isReadonlyRole)"
    image="/assets/images/upload-formate2.png"
  ></app-upload-box>

  <table *ngIf="attachments.length" class="mt-4 table table-condensed" aria-hidden="false">
    <thead>
      <tr>
        <th class="text-sm text-semi-bold border-top-0"></th>
        <th class="text-sm text-semi-bold border-top-0" i18n>Name</th>
        <th class="text-sm text-semi-bold border-top-0" i18n>Details</th>
        <th class="text-sm text-semi-bold border-top-0" i18n>Download</th>
        <th class="text-sm text-semi-bold border-top-0" i18n>Delete</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let item of attachments; let i = index">
        <td class="text-primary text-xxl">
          <i [ngClass]="item.name | fileIcon"></i>
        </td>
        <td>{{ item.name }}</td>
        <td>
          <span class="text-nowrap">
            {{ item.created | epoch : 'DD-MMM-YYYY' }} at {{ item.created | epoch : 'hh:mm A' }}
          </span>
          <br />
          <span class="text-light text-sm"> {{ item.user }} • {{ item.size | fileSize }} </span>
        </td>
        <td class="text-center align-middle">
          <button type="button" class="btn btn-light-info btn-sm" (click)="onDownloadAttachment(item)">
            <i class="cs-icon cs-icon-download"></i>
          </button>
        </td>
        <td class="text-center align-middle">
          <button
            type="button"
            class="btn btn-light-danger btn-sm"
            (click)="onDeleteAttachment(item)"
            *ngIf="!(1 | isReadonlyRole)"
          >
            <i class="cs-icon cs-icon-trash"></i>
          </button>
        </td>
      </tr>
    </tbody>
  </table>
</ng-template>
